export const HOME_TITLE = "Glotón";
